import(/* webpackMode: "eager", webpackExports: ["VideosListTabLayout"] */ "/app/apps/next/app/(tabs)/discover/discoverTab.tsx");
